import React from "react";


const styles = {
    p:{border:'1px solid gray', width:'380px', backgroundColor:'#ddd'},
    div:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#ddd'},
    divLogo:{textAlign:'center', width:'380px', padding:'0 20px', margin:'10px 0 0 0', backgroundColor:'#fff'},
    divWhite:{textAlign:'center', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
    divWhiteLeft:{border:'1px solid gray', width:'380px', padding:'0 20px 10px 20px', margin:'10px 0',backgroundColor:'#fff'},
    divWhiteLeftNoBorder:{width:'380px', padding:'10px 20px', margin:'10px 0',backgroundColor:'#fff'},
    li:{padding:'6px 0'},
}


export const setEmailBodyGeneral = ({ formValues, datosRegistro, extraContent = '' }) => {

    console.log(formValues, datosRegistro);

    const docAnexo = (formValues.tipoRegistroDocURL !== '') ? 
            <a href={ formValues.tipoRegistroDocURL }>
                <strong>Consultar documento probatorio</strong>
            </a>
        : '';


    // - Data adicional, para enlaces
    const detailsLink = 
    "<p>" +
        `Consulte la información general de su registro en <a href=${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${ formValues.registroReferencia }>este enlace</a>.<br />` +
        `Check your registration general information <a href=${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${ formValues.registroReferencia }>here</a>.` +
    "</p>" + 
    extraContent;

    return (
        <>
            <div style={styles.divLogo}>
                <img src={ datosRegistro.urlLogo } alt="logo" width={ 100 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>{ datosRegistro.tituloEvento }</i></h2>
            </div>
            {/* <div style={styles.divWhite}>
                <h3>¡Registro inicial completado con éxito!</h3>
            </div> */}
            <div style={styles.divWhiteLeft}>
                <p>
                    Nombre completo / Full name<br /> 
                    <strong>{ formValues.partNombres } { formValues.partApellidoPaterno } { formValues.partApellidoMaterno }</strong> <br /><br />
                    {/* Correo: <br /> */}
                    <strong>{ formValues.partCorreo }</strong> <br />
                    {
                        formValues.partPais !== ''
                        ? <span>
                            <br />Procedencia / Origin <br />
                            <strong>{ formValues.partEstado }, { formValues.partPais }</strong> 
                        </span>
                        : <span></span>
                    }
                    
                </p>
                {
                    formValues.tipoRegistro !== ''
                    ? <p>
                        <strong>{ formValues.tipoRegistro }</strong> { docAnexo }
                    </p>
                    : <span></span>
                }
                {
                    datosRegistro.modalidad
                    ? <p>Modalidad / Modality <br />
                        <strong>{ datosRegistro.modalidad }</strong>
                    </p>
                    : <span></span>
                }
                <p>
                    {/* Tipo de inscripción: <br />
                    <strong>{ formValues.tipoRegistro }</strong> { docAnexo }<br /><br /> */}
                    
                    Numero de referencia / Reference id <br />
                    <strong>{ formValues.registroReferencia }</strong>
                </p>

                <div dangerouslySetInnerHTML={{ __html: detailsLink }} />

            </div>
        </>
    );
};
